import React, {FC} from "react"

import {Tab} from "../index"
import Icon from "../../Icon"
import Flex from "../../Flex"
import theme from "../../global/theme"
import {StyledNav, StyledNavItem, StyledBadge} from "./styled"
import {Body, H6} from "@irati/ui/src/Typography"

interface Props {
  tabs: Tab[]
  fullWidth?: boolean
  activeColor?: string
  secondary?: boolean
}

const Headers: FC<Props> = ({tabs, fullWidth = false, activeColor = theme.colors.perkbox.blue, secondary}) => {
  return (
    <StyledNav bsStyle="pills">
      {tabs.map(({key, title, activeBadge, icon}) => (
        <StyledNavItem fullWidth={fullWidth} activeColor={activeColor} key={key} eventKey={key}>
          {secondary ? (
            <Flex alignItems="center">
              {icon && <Icon marginRight icon={icon} color={theme.colors.primary2} />}
              <Body small color={theme.colors.primary2}>
                {title}
              </Body>
            </Flex>
          ) : (
            <H6>
              {title}
              {activeBadge && <StyledBadge />}
            </H6>
          )}
        </StyledNavItem>
      ))}
    </StyledNav>
  )
}

export default Headers
